import React from "react";
import TitleSection from "../components/TitleSection/TitleSection";
import DescriptionBox from "../components/DescriptionBox";
import ServiceList from "../components/ServiceList";
import ContactFormPages from "../components/ContactFormPages";
import { Images } from "../assets";
import { useTranslation } from "react-i18next";

// Helper components defined in the same file
const TableCell = ({ children, className = "" }) => (
  <td className={`p-2 whitespace-nowrap ${className}`}>{children}</td>
);

const TableHeaderCell = ({ children, className = "" }) => (
  <th className={`p-2 whitespace-nowrap ${className}`}>{children}</th>
);

const Oxycoupage = () => {
  const { t } = useTranslation();

  const services = [
    { text: t("oxycoupage.services.0") },
    { text: t("oxycoupage.services.1") },
    { text: t("oxycoupage.services.2") },
    { text: t("oxycoupage.services.3") },
    { text: t("oxycoupage.services.4") },
  ];

  const servicesTable = [
    ["S235", "JRG2"],
    ["S355", "JRG2"],
    ["Quard", "400"],
    ["Quard", "450"],
    ["Quard", "500"],
    ["Quend", "700"],
    ["Quend", "960"],
    ["Hardox", "400"],
    ["Hardox", "450"],
    ["Hardox", "500"],
    ["Weldox", "700"],
    ["Weldox", "900"],
  ];

  const description = [
    t("oxycoupage.description.0"),
    t("oxycoupage.description.1"),
  ];

  const listDescription = [
    t("oxycoupage.listDescription.0"),
    t("oxycoupage.listDescription.1"),
    t("oxycoupage.listDescription.2"),
  ];

  return (
    <>
      <TitleSection
        title={t("oxycoupage.title")}
        subtitle={t("oxycoupage.subtitle")}
        highlightWords={t("oxycoupage.highlightWords", { returnObjects: true })}
        bgImg={Images.OXYCOUPAGE_BG_IMAGE}
      />

      <div className="flex flex-col gap-14 mx-5 md:mx-10 my-14">
        {/* Description and Services Section */}
        <section className="flex flex-col gap-5 md:flex-row">
          <DescriptionBox
            title={t("oxycoupage.descriptionTitle")}
            content={description}
            list={listDescription}
          />
          <ServiceList
            title={t("oxycoupage.servicesTitle")}
            services={services}
            table={servicesTable}
          />
        </section>

        {/* Additional Information Section */}
        <section className="flex flex-col gap-5 items-start text-start border-2 border-white rounded-xl px-5 py-10">
          <h2 className="text-xl">{t("oxycoupage.additionalInfo.title")}</h2>

          <ul className="space-y-5">
            <li className="flex gap-3">
              <img src={Images.ORANGE_TICK} alt="Tick Icon" />
              {t("oxycoupage.additionalInfo.items.0")}
            </li>
            <li className="flex gap-3">
              <img src={Images.ORANGE_TICK} alt="Tick Icon" />
              {t("oxycoupage.additionalInfo.items.1")}
            </li>
            <li className="flex gap-3">
              <img src={Images.ORANGE_TICK} alt="Tick Icon" />
              {t("oxycoupage.additionalInfo.items.2")}
            </li>
          </ul>
        </section>

        {/* Tolerances Table Section */}
        <section>
          <h2 className="font-title uppercase text-xl text-start mb-5 tracking-wide">
            {t("oxycoupage.tolerances.title")}{" "}
            <span className="text-orange">EN ISO 9013-442</span>
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className="bg-orange h-20">
                  <TableHeaderCell>
                    {t("oxycoupage.tolerances.headers.epaisseur")}
                  </TableHeaderCell>
                  <TableHeaderCell>35-315</TableHeaderCell>
                  <TableHeaderCell>315-1000</TableHeaderCell>
                  <TableHeaderCell>1000-2000</TableHeaderCell>
                  <TableHeaderCell>2000-4000</TableHeaderCell>
                </tr>
                <tr className="bg-orange">
                  <TableHeaderCell>
                    {t("oxycoupage.tolerances.headers.piece")}
                  </TableHeaderCell>
                  <TableHeaderCell>MM</TableHeaderCell>
                  <TableHeaderCell>MM</TableHeaderCell>
                  <TableHeaderCell>MM</TableHeaderCell>
                  <TableHeaderCell>MM</TableHeaderCell>
                </tr>
              </thead>
              <tbody>
                <tr className="h-12">
                  <TableCell>3 &lt; t ≤ 12</TableCell>
                  <TableCell>± 2,0</TableCell>
                  <TableCell>± 3,5</TableCell>
                  <TableCell>± 4,5</TableCell>
                  <TableCell>± 5,0</TableCell>
                </tr>
                <tr className="bg-white/50 h-12">
                  <TableCell>12 &lt; t ≤ 50</TableCell>
                  <TableCell>± 1,5</TableCell>
                  <TableCell>± 2,5</TableCell>
                  <TableCell>± 3,0</TableCell>
                  <TableCell>± 3,5</TableCell>
                </tr>
                <tr className="h-12">
                  <TableCell>12 &lt; t ≤ 50</TableCell>
                  <TableCell>± 2,5</TableCell>
                  <TableCell>± 3,5</TableCell>
                  <TableCell>± 4,0</TableCell>
                  <TableCell>± 4,5</TableCell>
                </tr>
                <tr className="bg-white/50 h-12">
                  <TableCell>100 &lt; t ≤ 150</TableCell>
                  <TableCell>± 3,0</TableCell>
                  <TableCell>± 4,0</TableCell>
                  <TableCell>± 5,0</TableCell>
                  <TableCell>± 6,0</TableCell>
                </tr>
                <tr className="h-12">
                  <TableCell>150 &lt; t ≤ 200</TableCell>
                  <TableCell>± 3,0</TableCell>
                  <TableCell>± 4,0</TableCell>
                  <TableCell>± 6,0</TableCell>
                  <TableCell>± 7,0</TableCell>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <ContactFormPages />
    </>
  );
};

export default Oxycoupage;
